module.exports = __webpack_public_path__ + "img/pfizer.5a3fc923.png";